/* eslint-disable no-fallthrough */
import { customStatusActionTypes } from '../../actions/configurations/customStatusActions';

const CustomStatusReducers = (state = {}, action) => {
  switch (action.type) {
  case customStatusActionTypes.GET_CUSTOM_STATUS.LOADING: {
    const { getCustomStatusLoading, entityType } = action;

    if (entityType === 'SALES_ESTIMATE') {
      return {
        ...state,
        getCustomStatusSalesEstimateLoading: getCustomStatusLoading,
      };
    }
    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        getCustomStatusSalesOrderLoading: getCustomStatusLoading,
      };
    }
    if (entityType === 'PACKING_SLIP') {
      return {
        ...state,
        getCustomStatusPackingSlipLoading: getCustomStatusLoading,
      };
    }
    if (entityType === 'INVOICE') {
      return {
        ...state,
        getCustomStatusInvoiceLoading: getCustomStatusLoading,
      };
    }
    if (entityType === 'CONSUMPTION_ORDER') {
      return {
        ...state,
        getCustomStatusConsumptionLoading: getCustomStatusLoading,
      };
    }
    if (entityType === 'ANNUAL_MAINTENANCE_CONTRACT') {
      return {
        ...state,
        getOrgStatusAnnualMaintenanceContractLoading: getCustomStatusLoading,
      };
    }
    if (entityType === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        getCustomStatusDeliveryChallanLoading: getCustomStatusLoading,
      };
    }
    if (entityType === 'QUALITY_CHECK') {
      return {
        ...state,
        updateQualityChecksStatusLoading: getCustomStatusLoading,
      };
    }

  }

  // eslint-disable-next-line no-fallthrough
  case customStatusActionTypes.GET_CUSTOM_STATUS.SUCCESS: {
    const { getCustomStatusSuccess, entityType } = action;

    if (entityType === 'SALES_ESTIMATE') {
      return {
        ...state,
        customStatusSalesEstimate: getCustomStatusSuccess,
      };
    }
    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        customStatusSalesOrder: getCustomStatusSuccess,
      };
    }
    if (entityType === 'PACKING_SLIP') {
      return {
        ...state,
        customStatusPackingSlip: getCustomStatusSuccess,

      };
    }
    if (entityType === 'INVOICE') {
      return {
        ...state,
        customStatusInvoice: getCustomStatusSuccess,

      };
    }
    if (entityType === 'CONSUMPTION_ORDER') {
      return {
        ...state,
        customStatusConsumption: getCustomStatusSuccess,

      };
    }
    if (entityType === 'ANNUAL_MAINTENANCE_CONTRACT') {
      return {
        ...state,
        customStatusAnnualMaintenanceContract: getCustomStatusSuccess,

      };
    }
    if (entityType === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        customStatusDeliveryChallan: getCustomStatusSuccess,

      };
    }
    if (entityType === 'QUALITY_CHECK') {
      return {
        ...state,
        customStatusQualityChecks: getCustomStatusSuccess,

      };
    }
  }

  case customStatusActionTypes.GET_ORG_STATUS.LOADING: {
    const { getOrgStatusLoading, entityType } = action;

    if (entityType === 'SALES_ESTIMATE') {
      return {
        ...state,
        getOrgStatusSalesEstimateLoading: getOrgStatusLoading,
      };
    }
    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        getOrgStatusSalesOrderLoading: getOrgStatusLoading,
      };
    }
    if (entityType === 'PACKING_SLIP') {
      return {
        ...state,
        getOrgStatusPackingSlipLoading: getOrgStatusLoading,
      };
    }
    if (entityType === 'INVOICE') {
      return {
        ...state,
        getOrgStatusInvoiceLoading: getOrgStatusLoading,
      };
    }
    if (entityType === 'CONSUMPTION_ORDER') {
      return {
        ...state,
        getOrgStatusConsumptionLoading: getOrgStatusLoading,

      };
    }
    if (entityType === 'ANNUAL_MAINTENANCE_CONTRACT') {
      return {
        ...state,
        getOrgStatusAnnualMaintenanceContractLoading: getOrgStatusLoading,

      };
    }
    if (entityType === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        getCustomStatusDeliveryChallanLoading: getOrgStatusLoading,

      };
    }
  }

  // eslint-disable-next-line no-fallthrough
  case customStatusActionTypes.GET_ORG_STATUS.SUCCESS: {
    const { getOrgStatusSuccess, entityType } = action;

    if (entityType === 'SALES_ESTIMATE') {
      return {
        ...state,
        orgStatusSalesEstimate: getOrgStatusSuccess,
      };
    }
    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        orgStatusSalesOrder: getOrgStatusSuccess,
      };
    }
    if (entityType === 'PACKING_SLIP') {
      return {
        ...state,
        orgStatusPackingSlip: getOrgStatusSuccess,

      };
    }
    if (entityType === 'INVOICE') {
      return {
        ...state,
        orgStatusInvoice: getOrgStatusSuccess,

      };
    }
    if (entityType === 'CONSUMPTION_ORDER') {
      return {
        ...state,
        orgStatusConsumption: getOrgStatusSuccess,

      };
    }
    if (entityType === 'ANNUAL_MAINTENANCE_CONTRACT') {
      return {
        ...state,
        orgStatusAnnualMaintenanceContract: getOrgStatusSuccess,

      };
    }
    if (entityType === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        customStatusDeliveryChallan: getOrgStatusSuccess,

      };
    }
  }

  case customStatusActionTypes.CREATE_CUSTOM_STATUS.LOADING: {
    const { createCustomStatusLoading } = action;
    return {
      ...state,
      createCustomStatusLoading,
    };
  }
  case customStatusActionTypes.UPDATE_CUSTOM_STATUS.LOADING: {
    const { updateCustomStatusLoading } = action;
    return {
      ...state,
      updateCustomStatusLoading,
    };
  }
  case customStatusActionTypes.DELETE_CUSTOM_STATUS.LOADING: {
    const { deleteCustomStatusLoading } = action;
    return {
      ...state,
      deleteCustomStatusLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default CustomStatusReducers;
